/*Appointment popup overlay PDP*/
document.addEventListener('DOMContentLoaded', function () {
    var triggerElements = document.querySelectorAll('.globo-formbuilder-open');
    var mainContent = document.getElementById('main-content');
    var styleElement;

    function handleClick() {
        mainContent.style.position = 'relative';
        mainContent.style.zIndex = '90';

        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.innerHTML = `
                .product-card, 
                button.globo-formbuilder-open[data-id="Mzc3ODE="] {
                    z-index: -1 !important;
                }
            `;
            document.head.appendChild(styleElement);
        }
    }
    
    // Add the click event listener to each trigger element
    triggerElements.forEach(function(triggerElement) {
        triggerElement.addEventListener('click', handleClick);
    });

    document.addEventListener('click', function(event) {
    var dismissElements = document.querySelectorAll('.header.dismiss');
    var isClickInsideTrigger = Array.from(triggerElements).some(function(triggerElement) {
        return triggerElement.contains(event.target);
    });

    var isClickInsideDismiss = Array.from(dismissElements).some(function(dismissElement) {
        return dismissElement.contains(event.target);
    });

    if (isClickInsideDismiss && !isClickInsideTrigger) {
        mainContent.style.position = '';
        mainContent.style.zIndex = '';

        if (styleElement) {
            styleElement.parentNode.removeChild(styleElement);
            styleElement = null;
        }
      }
   });
});
/*Appointment popup overlay PDP*/


/* StackAdapt GTM add to cart event */
custom_stack_adapt_event = function(){
    !function(s,a,e,v,n,t,z){
        if(s.saq)return;
        n=s.saq=function(){
            n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments)
        };
        if(!s._saq) s._saq=n;
        n.push=n; n.loaded=!0; n.version='1.0'; n.queue=[];
        t=a.createElement(e); t.async=!0; t.src=v;
        z=a.getElementsByTagName(e)[0];
        z.parentNode.insertBefore(t,z)
    }(window,document,'script','https://tags.srv.stackadapt.com/events.js');
    
    saq('ts', '8_imnm7opj8E33pFxdqjaA');  // This is your StackAdapt ID  
}

document.addEventListener("cart:item-added", function (evt) {
    //console.log("Cart item added");
    //console.log(evt.detail.product);
    //this event trigger is set up in GTM
    dataLayer.push({'event': 'add_to_cart'});

    //this is the provided script
    custom_stack_adapt_event();
});


/*Listen for click events on variant options PDP*/
// document.querySelectorAll('#Option-template--15094835675208__main-product-0').forEach(option => {
//   option.addEventListener('click', (event) => {
//     event.preventDefault();
//     let delayTime = 0; 

//     const userAgent = navigator.userAgent.toLowerCase();
    
//     if (userAgent.includes('chrome')) {
//       delayTime = 3000;
//     } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
//       delayTime = 3000; 
//     }

//     setTimeout(() => {
//       location.reload();
//     }, delayTime);
//   });
// });

/*Listen for click events on variant options PDP*/


/* ========================================
   STORE LOCATOR FUNCTIONALITY
   ======================================== */

// Store Locator Configuration
const STORE_LOCATOR_CONFIG = {
  selectors: {
    phone: ['.location-phone', '.location-list-item-phone'],
    email: ['.location-email', '.location-list-item-email'],
    clickable: '.location-list-item-marker a, .location-list-item-name, .location-list-item-address',
    container: '.location-list',
    mapContainer: '.map-container',
    useLocationBtn: '.use_my_location'
  },
  contexts: [
    '.leaflet-right .layer-custom-popup .leaflet-custom-popup-location-list .leaflet-custom-popup-location-item',
    '.location-item .location-list-item-details',
    '.leaflet-custom-popup-location-item'
  ],
  styles: {
    link: 'color: #CB2C30; cursor: pointer; text-decoration: none;'
  },
  timing: {
    initDelay: 1000,
    domDelay: 500,
    observerDelay: 100,
    retryDelay: 1000
  }
};

// Store Locator Class
class StoreLocator {
  constructor() {
    this.observer = null;
    this.isInitialized = false;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupMutationObserver();
  }

  setupEventListeners() {
    // Window load event
    window.addEventListener('load', () => {
      setTimeout(() => this.initializeLocationItems(), STORE_LOCATOR_CONFIG.timing.initDelay);
    });

    // DOMContentLoaded backup
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        if (this.hasStoreLocatorElements()) {
          this.initializeLocationItems();
        }
      }, STORE_LOCATOR_CONFIG.timing.domDelay);
    });
  }

  hasStoreLocatorElements() {
    return document.querySelector(STORE_LOCATOR_CONFIG.selectors.container) || 
           document.querySelector(STORE_LOCATOR_CONFIG.selectors.mapContainer);
  }

  initializeLocationItems() {
    const container = document.querySelector(STORE_LOCATOR_CONFIG.selectors.container);
    if (!container) return;

    // Remove existing listener to prevent duplicates
    container.removeEventListener('click', this.handleItemClick);
    container.addEventListener('click', this.handleItemClick.bind(this));

    // Auto-click "use my location" button
    this.autoClickUseLocation();

    // Convert phone/email links
    this.convertPhoneEmailLinks();

    this.isInitialized = true;
  }

  autoClickUseLocation() {
    const useLocationBtn = document.querySelector(STORE_LOCATOR_CONFIG.selectors.useLocationBtn);
    if (useLocationBtn) {
      useLocationBtn.dispatchEvent(new Event('click'));
    }
  }

  handleItemClick(e) {
    const clickable = e.target.closest(STORE_LOCATOR_CONFIG.selectors.clickable);
    if (!clickable) return;

    e.preventDefault();
    const item = clickable.closest('.location-item');
    if (!item) return;

    // Update active store
    this.updateActiveStore(item);

    // Handle mobile scroll
    if (window.innerWidth <= 768) {
      this.scrollToMap();
    }
  }

  updateActiveStore(activeItem) {
    document.querySelectorAll('.location-item').forEach(el => 
      el.classList.remove('active-store')
    );
    activeItem.classList.add('active-store');
  }

  scrollToMap() {
    const targetMap = document.querySelector(STORE_LOCATOR_CONFIG.selectors.mapContainer);
    if (targetMap) {
      const topPos = targetMap.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: topPos, behavior: 'smooth' });
    }
  }

  convertPhoneEmailLinks() {
    let totalConverted = 0;
    const allSelectors = [...STORE_LOCATOR_CONFIG.selectors.phone, ...STORE_LOCATOR_CONFIG.selectors.email];

    allSelectors.forEach(selector => {
      STORE_LOCATOR_CONFIG.contexts.forEach(context => {
        const elements = document.querySelectorAll(`${context} ${selector}`);
        
        elements.forEach(element => {
          if (this.shouldConvertElement(element)) {
            const text = element.textContent.trim();
            const isEmail = selector.includes('email');
            
            if (this.isValidText(text, isEmail)) {
              this.createClickableLink(element, text, isEmail);
              totalConverted++;
            }
          }
        });
      });
    });
  }

  shouldConvertElement(element) {
    return element.textContent && !element.querySelector('a');
  }

  isValidText(text, isEmail) {
    if (isEmail) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text);
    }
    return /[\d\s\+\-\(\)\.]+/.test(text);
  }

  createClickableLink(element, text, isEmail) {
    const link = document.createElement('a');
    link.href = isEmail ? `mailto:${text}` : `tel:${text.replace(/[\s\-\(\)\.]/g, '')}`;
    link.textContent = text;
    link.style.cssText = STORE_LOCATOR_CONFIG.styles.link;
    
    element.innerHTML = '';
    element.appendChild(link);
  }

  setupMutationObserver() {
    const mapContainer = document.querySelector(STORE_LOCATOR_CONFIG.selectors.mapContainer);
    
    if (mapContainer) {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            if (this.hasNewPopupContent(mutation.addedNodes)) {
              setTimeout(() => this.convertPhoneEmailLinks(), STORE_LOCATOR_CONFIG.timing.observerDelay);
            }
          }
        });
      });
      
      this.observer.observe(mapContainer, {
        childList: true,
        subtree: true
      });
    } else {
      setTimeout(() => this.setupMutationObserver(), STORE_LOCATOR_CONFIG.timing.retryDelay);
    }
  }

  hasNewPopupContent(addedNodes) {
    return Array.from(addedNodes).some(node => 
      node.nodeType === 1 && (
        node.classList?.contains('leaflet-custom-popup-location-item') || 
        node.querySelector?.('.leaflet-custom-popup-location-item') ||
        node.classList?.contains('location-item') ||
        node.querySelector?.('.location-item')
      )
    );
  }

  // Public methods for debugging
  debug() {
    this.initializeLocationItems();
    this.convertPhoneEmailLinks();
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Initialize Store Locator
const storeLocator = new StoreLocator();

// Expose debug function globally
window.debugStoreLocator = () => storeLocator.debug();

/* ========================================
   END STORE LOCATOR
   ======================================== */
